/**
 * Dashboard 相关的 TanStack Query Hooks
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { getDashboardStats } from '@/services/dashboardService'
import type { UserDashboardStats } from '@/types/dashboard'

/** Dashboard 查询 Key */
const DASHBOARD_STATS_QUERY_KEY = ['dashboard', 'stats'] as const

/**
 * 获取用户端 Dashboard 统计的 Hook
 * @param enabled 是否启用查询
 * @returns Dashboard 统计查询结果
 */
export function useDashboardStats(
  enabled = true
): UseQueryResult<UserDashboardStats> {
  return useQuery({
    queryKey: DASHBOARD_STATS_QUERY_KEY,
    queryFn: async (): Promise<UserDashboardStats> => {
      return await getDashboardStats()
    },
    enabled,
    staleTime: 30 * 1000,
  })
}

export { DASHBOARD_STATS_QUERY_KEY }
